import { useAxios } from '../Plugins/axios';
import { useRoute } from '../Plugins/ziggy';
export default class IrrigationService {
    axios;
    route;
    constructor() {
        this.axios = useAxios();
        this.route = useRoute();
    }
    getAll(orchard_id, plot_id) {
        return this.axios
            .get(this.route('api.irrigations.index', {
            plot_id: plot_id ?? '',
            orchard_id,
        }))
            .then((response) => response.data.data);
    }
    create(data) {
        return this.axios
            .post(this.route('api.irrigations.store'), data)
            .then((response) => response.data.data);
    }
    update(id, data) {
        data['_method'] = 'PUT';
        return this.axios
            .post(this.route('api.irrigations.update', { id }), data)
            .then((response) => response.data.data);
    }
    destroy(ids) {
        return this.axios
            .post(this.route('api.irrigations.destroyMultiple'), {
            _method: 'DELETE',
            ids,
        })
            .then((response) => response.data.data);
    }
}
